import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { GlobalDiscoverySettingsPage } from '../../../features/DiscoverySettingsForms/pages/GlobalDiscoverySettingsPage';
import { DiscoveryDataEnrichmentPage } from './DiscoveryDataEnrichment/DiscoveryDataEnrichmentPage';
import {
  GlobalDiscoveryConfiguration,
  globalDiscoveryConfigurationdRoutes,
} from './GlobalDiscoveryConfiguration/GlobalDiscoveryConfiguration';
import { SnapshotCollectionPage } from './SnapshotCollection/SnapshotCollectionPage';

export const discoverySnapshotsRoutes: RoutesTreeItem[] = [
  {
    path: '/settings/discovery-snapshots/global-discovery-configuration',
    element: <GlobalDiscoveryConfiguration />,
    children: globalDiscoveryConfigurationdRoutes,
  },
  {
    path: '/settings/discovery-snapshots/global-discovery-settings',
    element: <GlobalDiscoverySettingsPage />,
    requiredApiScope: { method: 'GET', path: '/settings' },
  },
  // Registered unconditionally; the ENABLE_LABELS flag is checked at render time
  // inside the page (feature flags are not loaded at module-eval time).
  {
    path: '/settings/discovery-snapshots/discovery-data-enrichment',
    element: <DiscoveryDataEnrichmentPage />,
    requiredApiScope: { method: 'GET', path: '/settings' },
  },
  {
    path: '/settings/discovery-snapshots/snapshot-collection',
    element: <SnapshotCollectionPage />,
    requiredApiScope: { method: 'GET', path: '/settings' },
  },
];
